var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "fixed-bottom text-center d-flex justify-content-center" },
    [
      _c("div", { staticClass: "row col-12 p-0" }, [
        _c("div", { staticClass: "col p-0" }, [
          _c(
            "a",
            {
              staticClass: "active",
              on: {
                click: function($event) {
                  return _vm.setPage("Home")
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-home" }),
              _c("span", [_vm._v("Home")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col p-0" }, [
          _c(
            "a",
            {
              class:
                _vm.indicators && _vm.indicators.kudosCnt > 0
                  ? "indicator"
                  : "",
              on: {
                click: function($event) {
                  return _vm.setPage("Messages")
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-comment-alt" }),
              _c("span", [_vm._v("Kudos")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col p-0" }, [
          _c(
            "a",
            {
              class:
                _vm.indicators && _vm.indicators.notificationCnt > 0
                  ? "indicator"
                  : "",
              on: {
                click: function($event) {
                  return _vm.setPage("Notifications")
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-bell" }),
              _c("span", [_vm._v("Notifications")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col p-0" }, [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  return _vm.setPage("More")
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-cog" }),
              _c("span", [_vm._v("Settings")])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0daefa4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0daefa4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/Footer.vue
// module id = null
// module chunks = 